import * as genericTicketsServices from './genericTicketsServices';

export { genericTicketsServices };
